import AuthenticationLayout from 'components/AuthLayout';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import useSWR from 'swr';
import User from 'types/User';
import NotFound from '../not-found';
import Redirect from '../redirect';
import VerifiedEmailRequired from '../user/error/verified-email-required';
import ChartSigned from './chart-signed';
import MentorRequired from './error/mentor-required';
import FillFormMentor from './fill-form';
import MentorshipRoutes from './mentorship/Routes';
import Profile from './profile';
import SignChart from './sign-chart';
import Signup from './signup';
import Welcome from './welcome';

const MentorRoutes: FC = () => {
  const { data, error } = useSWR<User>('/auth/profile');
  return data &&
    !error &&
    data.UserRole?.some((userRole) => userRole.role === 'MENTOR') ? (
    <Routes>
      <Route
        path="/"
        element={<Redirect href="/mentor/mentorship/edit-form" />}
      />
      <Route path="/signup" element={<Signup />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/fill-form" element={<FillFormMentor />} />
      <Route path="/fill-profile" element={<Profile />} />
      <Route path="/sign-chart" element={<SignChart />} />
      <Route path="/chart-signed" element={<ChartSigned />} />
      <Route path="/mentorship/*" element={<MentorshipRoutes />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  ) : (
    <Routes>
      <Route path="/signup" element={<Signup />} />
      <Route
        path="/*"
        element={
          error?.response?.status === 403 ? (
            <AuthenticationLayout src_image="/logo_institut_principal.png">
              <VerifiedEmailRequired />
            </AuthenticationLayout>
          ) : (
            <AuthenticationLayout src_image="/logo_institut_principal.png">
              <MentorRequired />
            </AuthenticationLayout>
          )
        }
      />
    </Routes>
  );
};

export default MentorRoutes;
